export interface ApiEnvelope<T> {
  success: boolean;
  data?: T;
  error?: {
    message?: string;
  };
  message?: string;
}

export const unwrapApiData = <T>(payload: ApiEnvelope<T> | T, fallbackMessage: string): T => {
  if (payload && typeof payload === 'object' && 'success' in payload) {
    const envelope = payload as ApiEnvelope<T>;
    if (!envelope.success) {
      throw new Error(envelope.error?.message || envelope.message || fallbackMessage);
    }

    return envelope.data as T;
  }

  return payload as T;
};

export const getApiErrorMessage = (error: any, fallbackMessage: string): string => {
  return (
    error?.response?.data?.error?.message ||
    error?.response?.data?.message ||
    error?.message ||
    fallbackMessage
  );
};

export const getFetchErrorMessage = async (
  response: Response,
  fallbackMessage: string,
): Promise<string> => {
  try {
    const body = await response.json();
    return body?.error?.message || body?.message || fallbackMessage;
  } catch {
    return fallbackMessage;
  }
};
